/* Night Operators round 4 (14 Oct 2026, lane R4-HELMETS-SLIDERS): FOM slider on the PVS-14 and PVS-31 dark kit cards.
   Bon: "make all FOM pickers across all my landing pages in the dark sections sliders instead of pill options".
   Same look as the ADV-COTI, ELF-FB20 and GPNVG-18 round 4 sliders. The page's own FOM pill buttons stay in the page,
   hidden: the slider presses them, so the price, the total, the button text and the cart lines are exactly what the
   pills already did. A MutationObserver on the hidden pills repaints the slider when the page changes them
   (housing switch, stock read). New file; nothing else depends on it. Remove the two tags to undo. */
(function () {
  "use strict";
  var ROOTS = ["no-pvs14", "no-pvs31"];

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function rangeOf(btn) { var m = (btn.textContent || "").match(/\d{4}-\d{4}/); return m ? m[0] : ""; }
  function deltaOf(btn) { var s = btn.querySelector("span"); var t = s ? (s.textContent || "").trim() : ""; return (/^\+\$/.test(t) && !/^\+\$0(\.00)?$/.test(t)) ? t : ""; }
  function pressed(b) { return b.getAttribute("aria-pressed") === "true"; }
  function off(b) { return b.disabled || b.getAttribute("aria-disabled") === "true"; }

  function build(label) {
    var block = label.parentElement; if (!block || block.hasAttribute("data-nofs-done")) return;
    var first = block.querySelector("button"); if (!first) return;
    var row = first.parentElement, pills = Array.prototype.slice.call(row.querySelectorAll(":scope > button"));
    if (pills.length < 2) return;
    block.setAttribute("data-nofs-done", "");
    var expl = block.querySelector(":scope > p");
    var card = block.closest("#bundles .grid > div") || block.parentElement;
    var housing = null;
    Array.prototype.slice.call(card.querySelectorAll(".mono.font-bold")).forEach(function (l) { if ((l.textContent || "").trim() === "HOUSING") housing = l.parentElement; });

    var n = pills.length;
    var box = el("div", "nofs"); box.setAttribute("data-nofs", "");
    var top = el("div", "nofs__top"), k = el("span", "nofs__k", "FOM (CLARITY)"), v = el("span", "nofs__v");
    var vr = el("span", "nofs__vr"), vd = el("span", "nofs__vd"); v.appendChild(vr); v.appendChild(vd);
    top.appendChild(k); top.appendChild(v);
    var track = el("div", "nofs__track"); track.appendChild(el("span", "nofs__rail")); var fill = el("span", "nofs__fill"); track.appendChild(fill);
    var dots = [];
    for (var i = 0; i < n; i++) { var d = el("span", "nofs__dot"); d.style.left = (i / (n - 1) * 100) + "%"; dots.push(d); track.appendChild(d); }
    var input = document.createElement("input");
    input.type = "range"; input.className = "nofs__in"; input.min = "0"; input.max = String(n - 1); input.step = "1";
    input.setAttribute("aria-label", "FOM (clarity), drag to pick the tube grade");
    track.appendChild(input);
    var labels = el("div", "nofs__labels"), lbs = [];
    pills.forEach(function (p, i) {
      var b = el("button", "", rangeOf(p).split("-")[0]); b.type = "button"; b.setAttribute("data-nofs-stop", String(i));
      b.addEventListener("click", function () { go(i, 0); }); lbs.push(b); labels.appendChild(b);
    });
    var note = el("p", "nofs__note");
    box.appendChild(top); box.appendChild(track); box.appendChild(labels); box.appendChild(note);
    /* the slider sits BESIDE the old block, never inside it: the PVS-14 page repaints every button inside that block */
    box.className = "nofs " + (block.className || "");
    block.parentNode.insertBefore(box, block.nextSibling);
    block.setAttribute("data-nofs-hidden", "");

    var last = -1;
    function current() {
      var i;
      for (i = 0; i < n; i++) if (pressed(pills[i]) && !off(pills[i])) return i;
      for (i = 0; i < n; i++) if (!off(pills[i])) return i;
      return 0;
    }
    function go(want, dir) {
      want = Math.max(0, Math.min(n - 1, want));
      var i = want;
      if (off(pills[i])) {
        i = -1;
        var order = [], s, j;
        for (s = 1; s < n; s++) { if (dir >= 0) order.push(want + s, want - s); else order.push(want - s, want + s); }
        for (j = 0; j < order.length; j++) { var c = order[j]; if (c >= 0 && c < n && !off(pills[c])) { i = c; break; } }
        if (i < 0) { sync(); return; }
      }
      if (!pressed(pills[i])) pills[i].click();
      sync();
    }
    input.addEventListener("input", function () { var w = Number(input.value); go(w, w - last); });
    input.addEventListener("change", function () { sync(); });

    function housingName() {
      if (!housing) return "";
      var on = housing.querySelector('button[aria-pressed="true"]');
      return on ? (on.textContent || "").replace(/\+.*$/, "").trim().toUpperCase() : "";
    }
    function sync() {
      var idx = current(); last = idx;
      input.value = String(idx);
      var pct = n > 1 ? idx / (n - 1) * 100 : 0;
      box.style.setProperty("--nofs-pct", pct + "%");
      var r = rangeOf(pills[idx]);
      vr.textContent = r; vd.textContent = deltaOf(pills[idx]);
      input.setAttribute("aria-valuetext", r + " FOM");
      var notes = [], h = housingName();
      pills.forEach(function (p, i) {
        var st = off(p) ? "sold" : "ok";
        dots[i].setAttribute("data-state", st); dots[i].setAttribute("data-on", String(i <= idx));
        lbs[i].setAttribute("data-state", st); lbs[i].setAttribute("aria-pressed", String(i === idx));
        lbs[i].disabled = st !== "ok";
        var rr = rangeOf(p);
        if (st === "sold") {
          var why = (h === "STANDARD" && rr === "1250-1350") ? rr + " in PRO housing only" : rr + " sold out";
          notes.push(why); lbs[i].title = why;
        } else { lbs[i].title = rr + " FOM" + (deltaOf(p) ? ", " + deltaOf(p) : ""); }
      });
      var ex = expl ? (expl.textContent || "").trim() : "Higher FOM, sharper and cleaner image.";
      note.textContent = ex + (notes.length ? " " + notes.join(", ") + "." : "");
    }
    var queued = false;
    var mo = new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; sync(); }); });
    mo.observe(row, { subtree: true, attributes: true, childList: true, characterData: true });
    if (expl) mo.observe(expl, { subtree: true, childList: true, characterData: true });
    if (housing) mo.observe(housing, { subtree: true, attributes: true, attributeFilter: ["aria-pressed"] });
    sync();
  }

  function init() {
    ROOTS.forEach(function (id) {
      var root = document.getElementById(id); if (!root) return;
      Array.prototype.slice.call(root.querySelectorAll(".mono.font-bold")).forEach(function (l) {
        if ((l.textContent || "").trim() === "FOM (CLARITY)") { try { build(l); } catch (e) { if (window.console) console.warn("FOM slider", e); } }
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
